import Swal from "sweetalert2";
import type { TFunction } from "i18next";

import type { Appointment } from "../services/appointmentService";

export type BatchHealthQueueItem = {
  clientId: number;
  name: string;
  serviceId?: number | null;
  initialTemplateId?: number | null;
};

export const appointmentToBatchHealthQueueItem = (
  appointment: Appointment,
  notAvailable: string
): BatchHealthQueueItem | null => {
  if (!appointment.client_id) {
    return null;
  }

  return {
    clientId: appointment.client_id,
    name: appointment.client?.name ?? notAvailable,
    serviceId: appointment.service_id,
    initialTemplateId: appointment.service?.client_record_template_id ?? null,
  };
};

/**
 * After saving a ficha opened from batch "Preencher primeira", offer the next
 * client still without a record (dismiss clears the rest of the queue).
 */
export const promptContinueBatchHealthQueue = async (
  next: BatchHealthQueueItem,
  remainingCount: number,
  t: TFunction
): Promise<"fill" | "dismiss"> => {
  const confirmation = await Swal.fire({
    title: t("studio.agenda.actions.arrived.batchQueueNextTitle"),
    text: t("studio.agenda.actions.arrived.batchQueueNextBody", {
      name: next.name,
      remaining: remainingCount,
    }),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: t("studio.agenda.actions.arrived.batchQueueNextFill"),
    cancelButtonText: t("studio.agenda.actions.arrived.batchMissingHealthLater"),
    confirmButtonColor: "#0ab39c",
    cancelButtonColor: "#878a99",
    reverseButtons: true,
  });

  return confirmation.isConfirmed ? "fill" : "dismiss";
};
